import axios from 'axios'
import { CP_API_URL } from 'lib/env'
import { createError } from 'requests/errors'

export const getDealList = async (filter) => {
  try {
    const res = await axios.post(CP_API_URL + '/deals/getDeals/all', filter)
    return res.data
  } catch (e) {
    return createError(e)
  }
}